// extracted by mini-css-extract-plugin
export default {"wrapper":"success_wrapper__PTjx5","logo":"success_logo__WOPFg","container":"success_container__tehUX","header":"success_header__NGIwU","p":"success_p__RefYT"};